import React from 'react';
import PropTypes from 'prop-types';
import time from 'yoda-core-components/lib/moment/Time';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';

const STATUS_COLOR_MAP = {
    Failed: dt(['text-[#E71324]']),
    Invalid: dt(['text-[#E71324]']),
    Submitted: dt(['text-[#E87722]']),
    Retry: dt(['text-[#E87722]']),
    Awarded: dt(['text-[#2E7D32]']),
    Already: dt(['text-[#2E7D32]']),
};

const getStatusLabel = (status, messagesTexts) => {
    try {
        return messagesTexts.missingPointsHistory.typeStatus[status] || status;
    } catch (e) {
        return status;
    }
};

const getStatusColorClass = (statusLabel) => {
    const key = Object.keys(STATUS_COLOR_MAP).find((k) => statusLabel.includes(k));
    return key ? STATUS_COLOR_MAP[key] : dt(['text-black']);
};

const NewMissingPointsDetails = ({ missingPointsHistory = {}, messagesTexts }) => {
    const rows = missingPointsHistory?.data || [];

    return (
        <div className={dt(['w-full', 'border-t', 'border-solid', 'border-[#D8D8D8]'])}>
            {rows.map((item, i) => {
                const statusLabel = getStatusLabel(item.transactionStatus, messagesTexts);
                const statusColorClass = getStatusColorClass(statusLabel);
                return (
                    <div
                        key={i} // eslint-disable-line react/no-array-index-key
                        className={dt([
                            'flex', 'flex-col', 'md:flex-row', 'md:justify-between',
                            'border-b', 'border-solid', 'border-[#D8D8D8]',
                            'bg-white',
                        ])}
                    >
                        {/* Left: date + receiptId + status */}
                        <div className={dt(['flex', 'flex-col', 'pt-4', 'px-4', 'pb-4', 'gap-1'])}>
                            <span className={dt(['text-small', 'text-black'])}>
                                {time(item.requestDate).format('MMM DD, YYYY')}
                            </span>
                            <span className={dt(['text-small', 'text-black'])}>
                                {item.receiptId}
                            </span>
                            <span className={dt(['text-small'])}>
                                Status{' '}
                                <b className={statusColorClass}>{statusLabel}</b>
                            </span>
                        </div>

                        {/* Right: Total + amount — gray-05 bg */}
                        <div className={dt([
                            'flex', 'flex-row', 'md:flex-col', 'justify-between', 'md:justify-center', 'items-center',
                            'py-3', 'px-4', 'bg-[#F2F2F2]', 'md:min-w-[80px]',
                        ])}>
                            <span className={dt(['text-small', 'text-[#4D4D4D]', 'leading-5'])}>
                                Total
                            </span>
                            <span className={dt(['font-semibold', 'text-small', 'text-black', 'leading-5'])}>
                                ${item.receiptAmount}
                            </span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};

NewMissingPointsDetails.propTypes = {
    missingPointsHistory: PropTypes.object,
    messagesTexts: PropTypes.object.isRequired,
};

NewMissingPointsDetails.defaultProps = {
    missingPointsHistory: {},
};

export default NewMissingPointsDetails;
